<button
  class="w-full"
  mat-stroked-button
  name="backButton"
  type="button"
  [disabled]="disableBackButton()"
  [routerLink]="backButtonRouterLink() ?? null"
  (click)="clickBackButton.emit($event)"
  >{{ backButtonLabel() | resolveTranslateAbleText }}</button
>
<button
  class="w-full"
  mat-flat-button
  name="submitButton"
  type="submit"
  [attr.form]="formId()"
  [disabled]="disableSubmitButton()"
  >{{ submitButtonLabel() | resolveTranslateAbleText }}</button
>
